import axios from 'axios';

// Create Axios instance
const axiosInstance = axios.create();

// Add a request interceptor
axiosInstance.interceptors.request.use((config) => {
  // Get token from local storage
  const token = localStorage.getItem('isha_token');

  // Modify the config object, adding the Authorization header
  if (token) {
    config.headers.Authorization = `${token}`;
  }

  // Return the modified config
  return config;
}, (error) => {
  // Handle request error here
  return Promise.reject(error);
});

// Function to search tickets by date
export const searchTicketsByDate = async (startDate, endDate) => {
  try {
    const response = await axiosInstance.get(`/api/tickets?startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  } catch (error) {
    console.error('Error searching tickets:', error);
    throw new Error('Error searching tickets');
  }
};

// Function to search tickets by date
export const searchAgentTicketsByDate = async (agentId, startDate, endDate) => {
  try {
    const response = await axiosInstance.get(`/api/agent-tickets?agentId=${agentId}&startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  } catch (error) {
    console.error('Error searching tickets:', error);
    throw new Error('Error searching tickets');
  }
};

// Function to search tickets where ticket.feedback_sent is not null and filtered by date
export const searchTicketsWithFeedbackSent = async (startDate, endDate) => {
  try {
    const response = await axiosInstance.get(`/api/tickets?startDate=${startDate}&endDate=${endDate}`);
    const filteredTickets = response.data.filter(ticket => ticket.feedback_sent !== null);
    return filteredTickets;
  } catch (error) {
    console.error('Error searching tickets with feedback sent:', error);
    throw new Error('Error searching tickets with feedback sent');
  }
};

// Function to search tickets where ticket.feedback_received is not null and filtered by date
export const searchTicketsWithFeedbackReceived = async (startDate, endDate) => {
  try {
    const response = await axiosInstance.get(`/api/tickets?startDate=${startDate}&endDate=${endDate}`);
    const filteredTickets = response.data.filter(ticket => ticket.feedback_received !== null);
    return filteredTickets;
  } catch (error) {
    console.error('Error searching tickets with feedback received:', error);
    throw new Error('Error searching tickets with feedback received');
  }
};

// Function to search tickets by ticket owner name and filtered by date
export const searchTicketsByOwnerName = async (ownerName, startDate, endDate) => {
  try {
    const response = await axiosInstance.get(`/api/tickets?startDate=${startDate}&endDate=${endDate}`);
    const filteredTickets = response.data.filter(ticket => ticket.ticket_owner_name === ownerName);
    return filteredTickets;
  } catch (error) {
    console.error('Error searching tickets by owner name:', error);
    throw new Error('Error searching tickets by owner name');
  }
};

// Function to search tickets by ticket owner name and filtered by date
export const SearchTicketByID = async (ticketId) => {
  try {
    const response = await axiosInstance.get(`/api/ticket/${ticketId}`);
    return response;
  } catch (error) {
    console.error('Error searching tickets by owner name:', error);
    throw new Error('Error searching tickets by owner name');
  }
};


// Function to search tickets by date
export const searchPerformanceByDate = async (startDate, endDate) => {
  try {
    const response = await axiosInstance.get(`/api/performances?startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  } catch (error) {
    console.error('Error searching tickets:', error);
    throw new Error('Error searching tickets');
  }
};

// Function to search tickets by date
export const searchPersonalPerformanceByDate = async (agentId, startDate, endDate) => {
  try {
    const response = await axiosInstance.get(`/api/personal-performances?agentId=${agentId}&startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  } catch (error) {
    console.error('Error searching tickets:', error);
    throw new Error('Error searching tickets');
  }
};


// Function to search refunds by ticket id
export const searchRefundsByTicketId = async (ticketId) => {
  try {
    const response = await axiosInstance.get(`/api/refund?ticketId=${ticketId}`);
    return response.data;
  } catch (error) {
    console.error('Error searching refunds:', error);
    throw new Error('Error searching refunds');
  }
}

// Function to search refunds by date
export const searchRefundsByDate = async (startDate, endDate) => {
  try {
    const response = await axiosInstance.get(`/api/refunds?startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  } catch (error) {
    console.error('Error searching refunds:', error);
    throw new Error('Error searching refunds');
  }
}